<template>
  <div class="header">
    <img id="logo-header" alt="CotriDrive" :src="require('@/assets/logo.png')">
    <div class="input-login">
      <ul>
        <li>
          <span>
            <label>Telefone</label>
              <input @keyup="applyMask(dadosCliente.telefone, '(##) #####-####')"
                class="input"
                @blur="verificar('telefone')"
                v-model="dadosCliente.telefone"  />
                <legend v-show="dadosCliente.telefone.length <= 14">Informe o telefone</legend>
          </span>
        </li>
        <li>
          <span>
            <label>Nome</label>
            <input v-model="dadosCliente.nome"
              class="input"
              required
              @blur="verificar('nome')"
              @keyup="verificar('nome')" />
              <legend v-show="dadosCliente.nome.length < 3">Informe o nome</legend>
          </span>
        </li>
      </ul>
      <ul>
        <li>
          <span>
            <label>Estabelecimento</label>
            <input class="input" disabled placeholder="Supermercado Panambi" v-model="dadosCliente.estabelecimento" />
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { reactive, ref, toRefs } from '@vue/reactivity'

export default {
  name: 'AppHeader',
  emits: ['login', 'logged'],
  components: {
  },
  setup (_, { emit }) {
    const tokens = ref({
      '#': { pattern: /\d/ },
      S: { pattern: /[a-zA-Z]/ },
      A: { pattern: /[0-9a-zA-Z]/ },
      U: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
      L: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() }
    })

    const dadosCliente = reactive({
      telefone: '',
      nome: '',
      estabelecimento: 'Supermercado Panambi'
    })

    const verificar = () => {
      if (dadosCliente.telefone.length >= 15 && dadosCliente.nome.length >= 3) {
        emit('login', dadosCliente)
        emit('logged', true)
      } else {
        emit('logged', false)
      }
    }

    return { dadosCliente, tokens, verificar }
  },
  methods: {
    applyMask (value, mask, masked = true) {
      value = value || ''
      var iMask = 0
      var iValue = 0
      var output = ''
      while (iMask < mask.length && iValue < value.length) {
        const cMask = mask[iMask]
        const masker = this.tokens[cMask]
        const cValue = value[iValue]
        if (masker) {
          if (masker.pattern.test(cValue)) {
            output += masker.transform ? masker.transform(cValue) : cValue
            iMask++
          }
          iValue++
        } else {
          if (masked) output += cMask
          if (cValue === cMask) iValue++
          iMask++
        }
      }
      this.dadosCliente.telefone = output
    }
  }
}
</script>

<style lang="scss">
  .header {
    display:flex;
    flex-wrap: wrap;
    background: #E5E5E3;
    /* For width smaller than 400px: */
    #logo-header {
      width: clamp(10%, 15%, 20%);
      height: auto;
      margin: 5px;
    }

    .input-login {
      background: #E5E5E3;
      margin-left: auto;
      margin-right: 1rem;
      margin-bottom: 0.5rem;

      ul {
        list-style: none;
      }
      ul li {
        display: inline-flex;
        align-self: stretch;
        margin-left: 1rem;
        float:left;
      }
    }
  }
</style>
